<template>
    <div v-if="!props.languageResources.isLoading" :class="props.customClassList">
        <DcfDropdown v-bind="props.languageResources.dcfDropdownProps" @on-select="onLanguageSelect">
            <template #button="{ open, isOpen, selected }">
                <DcfButton variant="tertiary" :icon="isOpen ? 'chevron-up' : 'chevron-down'" icon-right @click="open">
                    <DhfIcon name="system-globe" :width="16" :height="16" />
                    {{ selected ? selected.label : props.languageResources.currentLanguage }}
                </DcfButton>
            </template>
        </DcfDropdown>
    </div>
</template>

<script setup lang="ts">
import DhfIcon from '@/components/dhf-icon/dhf-icon.vue';
import { DcfDropdown } from '@miele/dcf-components-vue';
import { DcfButton } from '@miele/dcf-components-vue';
import type { IDropdownOption, ILanguageResources, ILanguageObject } from '@/types/shared-types';

interface ILanguageSelect {
    languageResources: ILanguageResources;
    customClassList: string;
}

const props = defineProps<ILanguageSelect>();

const onLanguageSelect = (selection: IDropdownOption): void => {
    const languageArray: ILanguageObject = props.languageResources.languageObject;
    const baseUrl = window.location.href;
    let redirectURL = new URL('', baseUrl);

    try {
        redirectURL = new URL(
            languageArray.languages.find((entry) => entry.hrefLang.toLowerCase() === selection.value.toLowerCase())
                ?.url ?? '',
            baseUrl
        );
    } catch (err) {
        console.error(err);
    } finally {
        if (redirectURL.href !== baseUrl) {
            window.location.href = redirectURL.href;
        }
    }
};
</script>

<style lang="scss">
@import './dhf-language-select.scss';
</style>
